import React from 'react';
import { IKBSearchResult } from '../../../types/KB/IKBSearchResult';
import { Checkbox } from "@progress/kendo-react-inputs";
import { Grid, GridColumn as Column, GridDataStateChangeEvent } from "@progress/kendo-react-grid";
import { process, State } from '@progress/kendo-data-query';
import ReactTimeAgo from 'react-timeago'
import { trimChar } from "../../../utils/utils";
import { nanoid } from "nanoid";
import { UserApi } from '../../../redux/api/UserApi';
import KBPreview from './KBPreview';


interface KBResultsProps {
    results: IKBSearchResult[];
    linkedKBIds?: number[];
    kbSelected?: (e: IKBSearchResult) => void;
}

const KBResults: React.FC<KBResultsProps> = ({ results, kbSelected, linkedKBIds }) => {
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const { data: tenant } = UserApi.useGetTenantQuery();
    const [previewKBId, setPreviewKBId] = React.useState<number>()
    const columns = [
        {
            title: "Article #",
            field: "KB_Id",
            show: true,
            filter: "text",
            orderIndex: 0,
            width: 80,
            cell: (props) => {
                return (
                    <td colSpan={props.colSpan} style={props.style}>
                        <a title='Open in new window' target={"_blank"} href={`${trimChar(tenant.Tenant_Url, '/')}/KBase/?Popup=0&KB_Id=${props.dataItem["ID"]}`}>{props.dataItem["KB_Id"]}</a>
                    </td>)
            }
        },
        {
            title: "Title",
            field: "Title",
            show: true,
            filter: "text",
            orderIndex: 1
        },
        {
            title: "Tags",
            field: "Keywords",
            show: true,
            filter: "text",
            orderIndex: 1
        },
        {
            title: "Updated",
            field: "Date_Updated",
            show: true,
            width: 120,
            filter: "text",
            orderIndex: 3,
            cell: (props) => {
                return (
                    <td colSpan={props.colSpan} style={props.style}>
                        <ReactTimeAgo date={new Date(props.dataItem["Date_Updated"] + 'Z')} />
                    </td>)
            }
        },
        {
            title: "Score",
            field: "Rating",
            show: true,
            filter: "text",
            orderIndex: 4,
            width: 80
        },
        {
            width: 50,
            cell: (props) => {
                return (
                    <td colSpan={props.colSpan} style={props.style}>
                        <button onClick={() => {
                            setPreviewKBId(props.dataItem["ID"]);
                        }} title="Preview" className="k-font-icon k-i-preview k-icon-48"></button>
                    </td>
                );
            },
            show: true,
            orderIndex: 5
        }
    ]

    const userState = ({ state: { take: 10, skip: 0 }, columns: null }) as { state: State, columns: [{ field: string, orderIndex: number }] }
    const [dataState, setDataState] = React.useState<State>(userState?.state || {});
    const dataStateChange = (event: GridDataStateChangeEvent) => {
        setDataState(event.dataState);
    };

    //Resset the page number when the data changes
    React.useEffect(() => {
        setDataState({ ...dataState, skip: 0 })
    }, [results?.length])

    return (
        <>
            {previewKBId && <KBPreview KB_ID={previewKBId} onClose={() => setPreviewKBId(null)} />}
            <Grid className='kb-results-grid'
                data={process(results || [], dataState)}
                {...dataState}
                onDataStateChange={dataStateChange}
                // onColumnReorder={columnReorder}
                sortable={true}
                groupable={false}
                pageable={true}
                reorderable={false}
            >
                <Column width={50} locked={true} reorderable={false}
                    key={nanoid()}
                    field=""
                    cell={(e) => {
                        if (e.rowType === 'groupHeader') return <></>;
                        return (
                            <td style={{ textAlign: 'center' }} className="chk">
                                <Checkbox title={`Link to ${userProfile?.Phrases.CallPhrase}`} checked={linkedKBIds?.indexOf(e.dataItem["ID"]) > -1} onChange={() => kbSelected(e.dataItem)} />
                            </td>)
                    }}
                />
                {columns?.map((column, idx) =>
                    column.show && (
                        <Column
                            key={idx}
                            orderIndex={column.orderIndex}
                            field={column.field}
                            title={column.title}
                            cell={column.cell}
                            width={column.width}

                        />
                    )
                )}
            </Grid>
        </>
    );
};

export default KBResults;